import React from 'react'
import { Link, useLocation } from 'react-router-dom'

function MenuButton({handleLinkClick}) {
  const location = useLocation();
  return (
    <div className='nav-mob' >
      <ul className="navbar-nav py-4 py-lg-0">
        <li className={`nav-item ${location.pathname === "/dashboard" ? "active" : ""}`} style={{ width: '12em' }}>
          <Link onClick={handleLinkClick} to="/dashboard" className="nav-link mob-nav-item" style={{ color: 'black', marginLeft: '0.5em' }}> All Companies</Link>
        </li>
        <li
          className={`nav-item ${location.pathname === "/product-purchase" ? "active" : ""
            }`}
          style={{ width: '12em' }}
        >
          <Link onClick={handleLinkClick} to="/product-purchase" className="nav-link mob-nav-item" style={{ color: 'black', marginLeft: '0.5em' }}>
            Companies That Buy
          </Link>
        </li>
        <li
          className={`nav-item ${location.pathname === "/product-produced" ? "active" : ""
            }`}
          style={{ width: '12em' }}
        >
          <Link onClick={handleLinkClick} to="/product-produced" className="nav-link mob-nav-item" style={{ color: 'black', marginLeft: '0.5em' }} >
            Companies That Sell
          </Link>
        </li>
        <li
          className={`nav-item ${location.pathname === "/service" ? "active" : ""
            }`}
          style={{ width: '12em' }}
        >
          <Link onClick={handleLinkClick} to="/service" className="nav-link mob-nav-item" style={{ color: 'black', marginLeft: '0.5em' }} >
            Services
          </Link>
        </li>
        <li
          className={`nav-item ${location.pathname === "/equipment" ? "active" : ""
            }`}
          style={{ width: '12em' }}
        >
          <Link onClick={handleLinkClick} to="/equipment" className="nav-link mob-nav-item" style={{ color: 'black', marginLeft: '0.5em' }}>
            Equipment
          </Link>
        </li>
      </ul>
    </div>
  )
}

export default MenuButton
